<template>
  <aside class="app-sidebar">
    <div class="app-sidebar__logo">
      <router-link to="/admin" class="header-brand">
        <h3 style="color: white;">پنل مدیریت عالیجناب</h3>
      </router-link>
    </div>
    <div class="app-sidebar3">
      <Menu></Menu>
    </div>
  </aside>
</template>

<script>
import SidebarImpl from '@@/core/components/shared/Sidebar/SidebarImpl'
export default {
  extends: SidebarImpl
}
</script>

<style src="@@/core/components/shared/Sidebar/SidebarStylePublic.css"></style>
